<template>
    <span class="item--color__price m-2">
        <b-skeleton v-if="isLoading" width="100%" />
        <template v-else>
            <template v-if="pricing.printable">
                {{ singlePrice | toCents | currency }}*
            </template>
            <template class="item--color__price" v-else>{{
                null | currency
            }}</template>
        </template>
    </span>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PrintModePrice',
    data() {
        return {
            singlePrice: 0,
        };
    },
    props: {
        currentColor: {
            type: Object,
            required: true,
        },
        printMode: {
            type: Object,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'currentCartItem',
            'current3DFile',
            'taxRate',
            'isBusinessCustomer',
        ]),
        pricing() {
            if (this.currentColor.pricing) {
                return this.currentColor.pricing;
            } else {
                return {
                    price: 0,
                    productionTimeDays: 0,
                    isPrintable: true,
                    tooLarge: false,
                    tooSmall: false,
                };
            }
        },
    },
    watch: {
        pricing(value) {
            this.singlePrice =
                (this.isBusinessCustomer
                    ? this.pricing.price.netPrice
                    : this.pricing.price.totalPrice) /
                this.currentCartItem.quantity;
        },
        isBusinessCustomer(value) {
            this.singlePrice =
                (this.isBusinessCustomer
                    ? this.pricing.price.netPrice
                    : this.pricing.price.totalPrice) /
                this.currentCartItem.quantity;
        },
    },
    created() {
        this.singlePrice =
            (this.isBusinessCustomer
                ? this.pricing.price.netPrice
                : this.pricing.price.totalPrice) /
            this.currentCartItem.quantity;
    },
    mounted() {
        //eventBus.$on('cartItemPricingInvalid', this.calculatePricing)
    },
    beforeDestroy() {
        //eventBus.$off('cartItemPricingInvalid', this.calculatePricing);
    },
};
</script>

<style scoped lang="scss"></style>
